import React from 'react';
import { useEffect, useState } from "react";
import { Field } from "redux-form";
import { FormGroup, Popup, Button } from "semantic-ui-react";
import {
  TextInput,
  FileInput,
  SelectInput,
  CheckboxInput,
} from "../../utils/form-fields";

const TextTab = ({ banner, handleUpload, change, template }) => {
  const [textOptions, setTextOptions] = useState([]);
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (template.variables) {
      const txtOptions = template.variables.find((item) => {
        return item.uniqueName === "TextPosition";
      });
      setTextOptions(getOptions(txtOptions.choices));
    }
  }, [template]);

  useEffect(() => {
    if (banner.fields) {
      setSelected(banner.fields.DrinkawareType);
    }
  }, [banner]);

  const getOptions = (options) => {
    let choices = [];
    if (!options) return choices;
    options.map((option) => {
      return (choices = [
        ...choices,
        { text: option.value, value: option.value, key: option.value },
      ]);
    });
    return choices;
  };

  const handleClick = (value) => {
    change(`fields.DrinkawareType`, value);
  };

  return (
    <>
      <FormGroup>
        <div className="field">
          <label>Desktop Text</label>
          {banner.fields &&
            banner.fields.DesktopText &&
            banner.fields.DesktopText.path && (
              <>
                <p>{Math.round(banner.fields.DesktopText.size / 1000)} kb</p>
                <img
                  src={banner.fields.DesktopText.path}
                  alt={banner.fields.MainTextDescription}
                />
              </>
            )}
          <Field
            name={`fields.DesktopText`}
            component={FileInput}
            fileName={
              banner.fields &&
              banner.fields.DesktopText &&
              banner.fields.DesktopText.name
                ? banner.fields.DesktopText.name
                : ""
            }
            callback={(file) =>
              handleUpload(
                file,
                `fields.DesktopText`,
                "Main text description",
                { maxWidth: 1120, height: 200 }
              )
            }
            handleFileRemove={(e) => change(`fields.DesktopText`, {})}
          />
        </div>
        <div className="field">
          <label>Tablet Text</label>
          {banner.fields &&
            banner.fields.TabletText &&
            banner.fields.TabletText.path && (
              <>
                <p>{Math.round(banner.fields.TabletText.size / 1000)} kb</p>
                <img
                  src={banner.fields.TabletText.path}
                  alt={banner.fields.MainTextDescription}
                />
              </>
            )}
          <Field
            name={`fields.TabletText`}
            component={FileInput}
            fileName={
              banner.fields &&
              banner.fields.TabletText &&
              banner.fields.TabletText.name
                ? banner.fields.TabletText.name
                : ""
            }
            callback={(file) =>
              handleUpload(file, `fields.TabletText`, "Main text description", {
                maxWidth: 600,
                height: 200,
              })
            }
            handleFileRemove={(e) => change(`fields.TabletText`, {})}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Field
          options={textOptions}
          component={SelectInput}
          name={`fields.TextPosition`}
          label="Align text"
          width="2"
        />
        <div className="field popup">
          <Popup
            content="Align the text left, right or center"
            trigger={<Button icon="question" />}
          />
        </div>
        <Field
          component={TextInput}
          name={`fields.MainTextDescription`}
          type="text"
          label="Text description"
          width="10"
        />
        <div className="field popup">
          <Popup
            content="For screen readers. Include the same text as the desktop text or tablet text."
            trigger={<Button icon="question" />}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Field
          component={CheckboxInput}
          name={`fields.Drinkaware`}
          label="Include Drinkaware logo"
          type="checkbox"
        />
      </FormGroup>
      {banner.fields.Drinkaware && (
        <FormGroup>
          <div className="field">
            <div
              className={`da white ${selected === "white" ? "selected" : ""}`}
              onClick={() => handleClick("white")}
            >
              <p>
                be <strong>drinkaware</strong>.co.uk
              </p>
            </div>
            <p>
              <em>Dark background</em>
            </p>
          </div>
          <div className="field">
            <div
              className={`da black ${selected === "black" ? "selected" : ""}`}
              onClick={() => handleClick("black")}
            >
              <p>
                be <strong>drinkaware</strong>.co.uk
              </p>
            </div>
            <p>
              <em>Light background</em>
            </p>
          </div>
          <div className="field">
            <div
              className={`da whitebg ${
                selected === "whitebg" ? "selected" : ""
              }`}
              onClick={() => handleClick("whitebg")}
            >
              <p>
                be <strong>drinkaware</strong>.co.uk
              </p>
            </div>
            <p>
              <em>Darkish background</em>
            </p>
          </div>
          <div className="field">
            <div
              className={`da blackbg ${
                selected === "blackbg" ? "selected" : ""
              }`}
              onClick={() => handleClick("blackbg")}
            >
              <p>
                be <strong>drinkaware</strong>.co.uk
              </p>
            </div>
            <p>
              <em>Lightish background</em>
            </p>
          </div>
        </FormGroup>
      )}
    </>
  );
};

export default TextTab;
